export default __webpack_public_path__ + "static/media/spinner.c25db4d2.gif";